<template>
  <div class="lessonDetail flexcenter">
    <transition>
      <div class="detail flexcenter">
        <!-- 閉じる -->
        <div class="modal-close" v-on:click="$emit('close')"></div>

        <!-- title -->
        <div class="flexbox title">
          <div class="titlethumb">
            <div class="thumb" :style="{ 'background-image': 'url('+lessonJson.thumbnail+')' }"></div>
          </div>
          <div class="lvl">
            <div class="lvl-sorange font12 mr10">レベル {{ levelNo }} </div>
            <div class="lvl-text lbold font20 mt10">ユニット {{ unitNo }} 「{{ unitTitle }}」: レッスン {{ lessonIndex+1 }}</div>
          </div>
        </div>

        <!-- 進捗一覧 -->
        <div class="flexstart progress-list">
          <div v-for="(path, pathIndex) in lessonJson.paths" v-on:click="clickLessonDetail(pathIndex)" class="progress-item">
            <div class="list-item">
              <div v-if="getPathState(pathIndex) === 'gone'" class="gone"><span class="icon"></span><span class="pathtitle lbold font16">{{ path.title }}</span><div class="rate"><span class="ratetitle font14 block">正解率</span><div class="align-center"><span class="font40 lbold textgreen">{{ getAnswerRate(pathIndex) }}</span><span class="lbold font20 textgreen">%</span></div></div></div>
              <div v-else-if="getPathState(pathIndex) === 'going'" class="going"><span class="icon"></span><span class="pathtitle lbold font16">{{ path.title }}</span><span class="going-text font28">進行中</span></div>
              <div v-else class="pending"><span class="icon"></span><span class="pathtitle lbold font16">{{ path.title }}</span></div>
            </div><!-- /.list-item -->
            <div class="ar_link"></div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import * as storeConstants from '@/store/constants'
import common from '@/mixin/common'

export default {
  name: 'lessonDetail',
  props: {
    levelNo: Number,
    unitNo: Number,
    unitTitle: String,
    lessonIndex: Number,
    lessonJson: Object
  },
  data: function() {
    return {
      lessonScore: null
    }
  },
  mixins: [
    common,
  ],
  methods: {
    /**
     * 正解率を取得
     */
    getAnswerRate: function(pathIndex) {
      return this.lessonScore.paths[pathIndex].answerRate
    },
    /**
     * ステータスを取得
     */
    getPathState: function(pathIndex) {
      var res = ''

      switch (this.lessonScore.paths[pathIndex].status) {
        case storeConstants.PATH_STATE_COMPLETED:
          res = 'gone'
          break
        case storeConstants.PATH_STATE_IN_PROGRESS:
          res = 'going'
          break
        default:
          break
      }

      return res
    },
    /**
     * レッスンパス選択時の処理
     */
    clickLessonDetail: function(pathIndex) {
      this.log("LessonDetail start clickLessonDetail")

      if(this.isEnvironmentPc()) {
        this.$emit('clickLessonDetail', this.lessonIndex, pathIndex)
      } else {
        // 選択されたpathから、最後に実施したpathStepを取得
        var params = {levelNo: this.levelNo, unitNo: this.unitNo, lessonIndex: this.lessonIndex, pathIndex: pathIndex}
        var pathStepIndex = this.$store.getters.filterProgress(params)
        if(pathStepIndex == -1) {
          pathStepIndex = 0
        }

        this.$emit('startLessonForMobile', this.levelNo, this.unitNo, this.lessonIndex, pathIndex, pathStepIndex)
      }
    }
  },
  created: function() {
    var params = {levelNo: this.levelNo, unitNo: this.unitNo, lessonIndex: this.lessonIndex}
    this.lessonScore= this.$store.getters.lesson(params)
  },
  mounted: function() {
    this.log("LessonDetail start mounted")
    this.setBodyStylePosition(true)
  },
  beforeDestroy: function() {
    this.setBodyStylePosition(false)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// LessonDetail.vue?5f66bd76